import dayjs from 'dayjs';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { fetch as axios } from '../../axios_config';

import { handleRejectedResponse } from './utils';

import UploadFileToUrl from '../utils/upload-file';

export const GetPresignedUrl = createAsyncThunk(
  'awsServices/getPresignedUrl',
  async (body, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const userId = state?.auth?.currentUser?.id;

      const { files, fileData } = body || {};
      const payload = files.map((file) => {
        return { name: `${userId}-${new Date().toISOString()}-${file.name}` };
      });
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/aws-services/presigned-url`, { files: payload });
      const { preSignedUrls } = response.data;

      const uploadFiles = [];

      const attachments = preSignedUrls.map((url, index) => {
        const file = files[index];
        const extension =  file?.name?.split('.')?.pop();

        if (fileData) {
          uploadFiles.push(UploadFileToUrl(url, fileData, extension));
        } else {
          uploadFiles.push(UploadFileToUrl(url, file, extension));
        }
        const downloadLink = new URL(url);
        downloadLink.search = '';
        return {
          name: file.name,
          key: file.name,
          url: downloadLink.toString(),
          extension,
          date: dayjs().toISOString()
        };
      });
      await Promise.all(uploadFiles);
      return attachments;
    } catch (err) {

      return handleRejectedResponse(err, 'Uploading File', rejectWithValue);
    }
  }
);

export const StoreProductsFile = createAsyncThunk(
  'awsServices/storeProductsFile',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/aws-services/store-products-file`,
        body
      );
      return response.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Uploading File', rejectWithValue);
    }
  }
);

const awsSlice = createSlice({
  name: 'awsServices',
  initialState: {
    presignedUrl: '',
    message: '',
    err: '',
    success: false,
    loading: false
  },
  extraReducers: {
    [GetPresignedUrl.pending]: (state) => ({
      ...state,
      loading: true
    }),
    [GetPresignedUrl.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.presignedUrl = payload.url;
    },
    [GetPresignedUrl.rejected]: (state, { payload }) => ({
      ...state,
      err: payload?.error?.error || payload?.error,
      loading: false
    }),
    [StoreProductsFile.pending]: (state) => ({
      ...state,
      loading: true
    }),
    [StoreProductsFile.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.message = payload.message;
    },
    [StoreProductsFile.rejected]: (state, { payload }) => ({
      ...state,
      err: payload?.error?.error || payload?.error,
      loading: false
    })
  }
});

const { reducer } = awsSlice;

export default reducer;
